import { render, staticRenderFns } from "./IconContractWait.vue?vue&type=template&id=06b91d56&"
import script from "./IconContractWait.vue?vue&type=script&lang=ts&"
export * from "./IconContractWait.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports